// Planes de pago por nivel (con fallback al set "General").
export const PLAN_KEYS = ["basico", "medio", "completo"];
export const PLAN_LABELS = { basico: "Básico", medio: "Medio tiempo", completo: "Tiempo completo" };
export const PLAN_LEVELS = ["Preescolar", "Primaria baja", "Primaria alta", "Secundaria"];
// Niveles seleccionables para un alumno (incluye "Primaria" heredado y Preparatoria).
export const STUDENT_LEVELS = ["Preescolar", "Primaria baja", "Primaria alta", "Primaria", "Secundaria", "Preparatoria"];

// Número de grado a partir de "1A", "3°B", "6" -> "1","3","6" (ignora el grupo A/B).
export function gradeNum(g) {
  const s = String(g || "").replace(/\s+/g, "");
  const m = s.match(/^\d+/);
  if (m) return m[0];
  return s.toUpperCase();
}

// Importe del plan según nivel y (opcional) grado del alumno.
// Prioridad: importe por GRADO del nivel > importe del NIVEL > importe General.
export function planAmount(user, level, key, grade) {
  const lv = (level || "").trim().toLowerCase();
  const lvls = user?.payment_plans_levels || {};
  let lvObj = null;
  for (const k in lvls) {
    if (k.trim().toLowerCase() === lv && lvls[k]) { lvObj = lvls[k]; break; }
  }
  if (lvObj) {
    if (grade !== undefined && grade !== null && grade !== "" && lvObj.grades) {
      const gn = gradeNum(grade);
      for (const gk in lvObj.grades) {
        if (gradeNum(gk) === gn) {
          const amt = Number((lvObj.grades[gk] || {})[key] || 0);
          if (amt > 0) return amt;
          break;
        }
      }
    }
    const amt = Number(lvObj[key] || 0);
    if (amt > 0) return amt;
  }
  return Number((user?.payment_plans || {})[key] || 0);
}

// ¿Hay al menos un plan con importe (General, por nivel o por grado)?
export function hasAnyPlans(user) {
  const g = user?.payment_plans || {};
  if (PLAN_KEYS.some((k) => Number(g[k]) > 0)) return true;
  const lv = user?.payment_plans_levels || {};
  return Object.values(lv).some((o) => {
    if (!o) return false;
    if (PLAN_KEYS.some((k) => Number(o[k]) > 0)) return true;
    const grades = o.grades || {};
    return Object.values(grades).some((gv) => gv && PLAN_KEYS.some((k) => Number(gv[k]) > 0));
  });
}
